// 地図要素表示切り替え
export const mapSetting = (type, hallMap, salonMap) => {
  if (type === "hall") {
    hallMap?.style?.setProperty("display", "block");
    salonMap?.style?.setProperty("display", "none");
  } else {
    hallMap?.style?.setProperty("display", "none");
    salonMap?.style?.setProperty("display", "block");
  }
};

// タブのアクティブ切り替え
export const tabSetting = (type) => {
  const activeClass = [
    "is-active",
    "background-color--accent",
    "border-color--accent",
  ];
  const inActiveClass = [
    "background-color--page_bg",
    "border-color--border",
    "color--text",
  ];

  document.querySelectorAll("#tabs--map li").forEach((liItem) => {
    liItem.querySelectorAll("a").forEach((aItem) => {
      aItem.classList.remove(...activeClass);
      aItem.classList.add(...inActiveClass);
    });
  });

  document.querySelectorAll(`.map__item.${type}`).forEach((liItem) => {
    liItem.querySelectorAll("a").forEach((aItem) => {
      aItem.classList.remove(...inActiveClass);
      aItem.classList.add(...activeClass);
    });
  });
};
